<script>
  export default {
    name: "AtomStatusPill",
    props: {
      label: { type: String, default: "Actual" },
      variant: {
        type: String,
        default: "success",
        validator: (v) => ["success", "info", "warning", "danger", "neutral", "free", "private", "both"].includes(v),
      },
    },
  };
</script>

<template>
  <span :class="[`status-pill--${variant}`, 'status-pill']">
    {{ label }}
  </span>
</template>

<style lang="scss" scoped>
  .status-pill {
    @include Flex(row, center, center);
    border-radius: 50%;
    padding: 6px 12px;
    font-size: 14px;

    &--success {
      font-family: $newFont_medium;
      height: 22px;
      padding: 10px;
      border-radius: 5px;
      border: 1px solid #2a9742;
      background: #f0fcf3;
      color: #2a9742;
      font-size: 12px;
      font-weight: 500;
    }

    &--info {
      color: #007bff;
      background: rgba(0, 123, 255, 0.08);
    }
    &--warning {
      color: #e6a100;
      background: rgba(230, 161, 0, 0.08);
    }
    &--danger {
      color: #c61111;
      background: rgba(198, 17, 17, 0.08);
    }
    &--neutral {
      color: #666666;
      background: rgba(102, 102, 102, 0.08);
    }

    &--free {
      color: #7f19ad;
      background: linear-gradient(0deg, rgba(127, 25, 173, 0.23) -101.47%, rgba(246, 228, 254, 0.23) 126.47%);

      border-radius: 19px;

      padding: 4px 14px;
      font-family: $newFont_medium;
    }

    &--private {
      color: #bd0909;
      background: linear-gradient(0deg, rgba(189, 9, 9, 0.13) 14.39%, rgba(255, 245, 245, 0.13) 152.94%);

      border-radius: 19px;

      padding: 4px 14px;
      font-family: $newFont_medium;
    }

    &--both {
      color: #ef9e25;
      background: rgba(239, 158, 37, 0.13);

      border-radius: 19px;

      padding: 4px 14px;
      font-family: $newFont_medium;
    }
    &--group {
      color: #1f86cb;
      background: rgba(31, 134, 203, 0.13);

      border-radius: 19px;

      padding: 4px 14px;
      font-family: $newFont_medium;
    }
  }
</style>
